import {createBrowserHistory} from 'history';
import {getEcardIdFromURL} from './utils/ecard';

const getBasename = () => {
  const path = window.location.pathname;
  if (path.startsWith('/cards')) return '/cards';
  if (path.startsWith('/card')) {
    const ecardId = getEcardIdFromURL();
    return `/card/${ecardId}`;
  }
  return '/';
};

export const history = createBrowserHistory({basename: getBasename()});
